window.addEventListener("DOMContentLoaded", () => {
  const serviceContainer = document.querySelector(".swiper-container");
  let serviceSlider = null;

  if (serviceContainer) {
    serviceSlider = new Swiper(serviceContainer, {
      slidesPerView: 1,
      spaceBetween: 20,
      grabCursor: true,
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: {
        575: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
        1400: {
          slidesPerView: 4,
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    // Autoplay handling on hover (only when slider/DOM are present)
    if (serviceSlider && serviceSlider.el && serviceSlider.autoplay) {
      serviceSlider.el.addEventListener("mouseenter", () => {
        serviceSlider.autoplay.stop();
      });

      serviceSlider.el.addEventListener("mouseleave", () => {
        serviceSlider.autoplay.start();
      });
    }
  }

  // used in detail page
  const swiper = new Swiper(".mySwiper", {
    spaceBetween: 10,
    slidesPerView: "4",
    freeMode: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
  const swiper2 = new Swiper(".mySwiper2", {
    // loop: true,
    spaceBetween: 10,
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });

  if (document.querySelector(".blog-detail__slider")) {
    new Swiper(".blog-detail__slider", {
      slidesPerView: 1.15,
      spaceBetween: 16,
      grabCursor: true,
      loop: true,
      speed: 600,
      navigation: {
        nextEl: ".blog-detail__related-next",
        prevEl: ".blog-detail__related-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 1.4,
          spaceBetween: 18,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1440: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
    });
  }

  const LuckyMotorBlog = document.querySelector(".lucky-motors-slider");
  if(LuckyMotorBlog){
    const swiper3 = new Swiper('.lucky-motors-slider', {
              loop: false,
              navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
              },
  
              breakpoints: {
                  0: {
                      slidesPerView: 1,
                      centeredSlides: false,
                      slidesPerView: 1,
                  },
                  768: {
                      slidesPerView: 2,
                      centeredSlides: false,
                  },
                  1024: {
                      // Desktop — Center Mode
                      slidesPerView: 3,
                      centeredSlides: false,
                      spaceBetween: 10,
                  }
              }
          });

  }

});
